// Utils
// eslint-disable-next-line import/no-cycle
import { resolveObjectOrNestedObjectsToObjectIds } from './resolveObjectOrNestedObjectsToObjectIds';
/**
 * Encodes the nested objects of the given array such that objects are converted to encoded object
 * id references.
 *
 * @see encodeObject
 *
 * @param {any[]} values
 *
 * @return {any[]}
 */
export var resolveNestedObjectsToObjectIdsForArray = function (values) { return values.map(resolveObjectOrNestedObjectsToObjectIds); };
//# sourceMappingURL=resolveNestedObjectsToObjectIdsForArray.js.map